import React, { PropTypes } from 'react';
import axios from './../../constants/axios';
import { Table, Button } from 'react-bootstrap';
import debounce from 'lodash/debounce';
import alert from 'alertify.js';

class OrderDetails extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         order: {},
         busy: true,
      };
   }

   componentDidMount() {
      const { id } = this.props.params;
      axios.get('saleOrders/' + id)
         .then((res) => {
            this.setState({
               order: res.data,
               busy: false,
            });
         });
   }

   transferOrderToInvoice = (id) => {
      this.setState({
         busy: true,
      });
      axios.put('saleOrders/transferToInvoice/' + id)
         .then((res) => {
            if (res.status === 201) {
               this.context.router.push('/sale/saleInvoiceDetail/' + res.data);
            }
         })
         .catch(err => {
            alert.error(err.response.data);
         })
         .finally(() => {
            this.setState({
               busy: false,
            });
         });
   };

   render() {
      const { order, busy } = this.state;
      return (
         <div className="OrderDetails" >
            <h3 >Order Details</h3 >
            <div >
               <p >OrderId: {order.id}</p >
               <p >Contact Name: {order.contact_name}</p >
               <p >Contact Mobile: {order.contact_mobile}</p >
               <p >Type: {order.outlet_id ? "Self Pick" : "Home Deliver"}</p >
               {!order.outlet_id && <address >
                  Address:
                  {order.contact_address}, {" "}
                  {order.district_name}, {" "}
                  {order.thana_name}
               </address >}
               <p >Total Amount: {order.total_amount}</p >
               <p >Created At: {order.created_at}</p >
               <p >Delivery Time: {order.delivery_time}</p >
            </div >
            <Button disabled={busy} onClick={debounce(() => this.transferOrderToInvoice(order.id), 500)} >Transfer To
               Invoice</Button >
            <hr />
            <h3 >Items</h3 >
            {order.items && <Table >
               <thead >
               <tr >
                  <th >ItemId</th >
                  <th >Name</th >
                  <th >Unit</th >
                  <th >Price</th >
                  <th >Discount</th >
               </tr >
               </thead >
               <tbody >
               {order.items.map((i) => <tr key={i.id} >
                  <td >{i.item_id}</td >
                  <td >{i.name}</td >
                  <td >{i.unit}</td >
                  <td >{i.price}</td >
                  <td >{i.unit_discount}</td >
               </tr >)}
               </tbody >
            </Table >}
         </div >
      );
   }
}

OrderDetails.propTypes = {
   params: PropTypes.object,
};
OrderDetails.contextTypes = {
   router: PropTypes.object
};

export default OrderDetails;



/** WEBPACK FOOTER **
 ** ./src/components/OrderManagement/OrderDetails.js
 **/